import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideoCameraRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.4 8.8q-.7.1-.8.8v12.8q.1.7.8.8h12.8q.7-.1.8-.8V9.6q-.1-.7-.8-.8zm-3.2.8c0-1.8 1.4-3.2 3.2-3.2h12.8c1.8 0 3.2 1.4 3.2 3.2v12.8c0 1.8-1.4 3.2-3.2 3.2H6.4a3 3 0 0 1-3.2-3.2zM28.5 9l.7-.2q1.1 0 1.2 1.2v12a1.2 1.2 0 0 1-2 1l-3.6-2.8v-3l3.2 2.4v-7.2l-3.2 2.4v-3z" })
});
export default SvgVideoCameraRegularIcon;
